export const reactClaim = 'REACT';
export const proClaim = 'PRO';

const hasProductClaims = (userClaims, requiredClaims) =>
	requiredClaims.some(claim => userClaims.includes(claim));

export default hasProductClaims;
